import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class BusinessService {
  constructor(private http: HttpClient) {}

  createBusinessFromPlaceId(
    placeId: string,
    salesPersonId: string,
    partnerId: string,
    marketId?: string,
  ): Observable<string> {
    const url = `/public/v1/account/create-from-place-id/`;
    const data = {
      placeId,
      salesPersonId,
      partnerId,
      marketId,
    };

    return this.http.post(url, data).pipe(map((res: any) => res.data));
  }

  createBusiness(name: string, salesPersonId: string, partnerId: string, marketId?: string): Observable<string> {
    const url = `/public/v1/account/create/?apiUser=publicstore&apiKey=xhtXkNdR8q52rcWW`;
    const data = {
      name,
      salesPersonId,
      partnerId,
      marketId,
    };

    return this.http.post(url, data).pipe(map((res: any) => res.data));
  }
}
